import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class CorporateSetupProgress extends Component {
    render() {
        return (
            <div>
                <ul className="setup-progress">
                    <li className={this.props.setUpProgress.companyDetailsDisabled === false ? this.props.setUpProgress.companySetupProgress : this.props.setUpProgress.companySetupProgress + ' disabled'}>
                        <span className="completed"><i className="icon-check"></i></span>
                        <span className="setup-progress-count">1</span>
                        <span className="setup-progress-name">
                            <Link to="companysetup">Company Setup</Link>
                        </span>
                    </li>
                    <li className={this.props.setUpProgress.productDetailsDisabled === false ? this.props.setUpProgress.productSetupProgress : this.props.setUpProgress.productSetupProgress + ' disabled'}>
                        <span className="completed"><i className="icon-check"></i></span>
                        <span className="setup-progress-count">2</span>
                        <span className="setup-progress-name">
                            <Link to="productsetup">Product Setup</Link>
                        </span>
                    </li>
                    <li className={this.props.setUpProgress.misDetailsDisabled === false ? this.props.setUpProgress.misSetupProgress : this.props.setUpProgress.misSetupProgress + ' disabled'}>
                        <span className="completed"><i className="icon-check"></i></span>
                        <span className="setup-progress-count">3</span>
                        <span className="setup-progress-name">
                            <Link to="misfieldsetup">Mis Field Setup</Link>
                        </span>
                    </li>
                    <li className={this.props.setUpProgress.scorecardDetailsDisabled === false ? this.props.setUpProgress.scorecardSetupProgress : this.props.setUpProgress.scorecardSetupProgress + ' disabled'}>
                        <span className="completed"><i className="icon-check"></i></span>
                        <span className="setup-progress-count">4</span>
                        <span className="setup-progress-name">
                            <Link to="scorecardsetup">Scorecard Setup</Link>
                        </span>
                    </li>
                </ul>
            </div>
        )
    }
}

//finished
//current
export default CorporateSetupProgress